export const estadoFitoConfig: Record<string, { badge: string; label: string }> = {
  bom: { badge: "bg-primary-100 text-primary-700", label: "Bom" },
  BOM: { badge: "bg-primary-100 text-primary-700", label: "Bom" },
  regular: { badge: "bg-warning-100 text-warning-700", label: "Regular" },
  REGULAR: { badge: "bg-warning-100 text-warning-700", label: "Regular" },
  ruim: { badge: "bg-danger-100 text-danger-700", label: "Ruim" },
  RUIM: { badge: "bg-danger-100 text-danger-700", label: "Ruim" },
  critico: { badge: "bg-danger-50 text-danger-600 border border-danger-300", label: "Crítico" },
  CRITICO: { badge: "bg-danger-50 text-danger-600 border border-danger-300", label: "Crítico" },
  morto: { badge: "bg-background-100 text-foreground-500", label: "Morto" },
  MORTO: { badge: "bg-background-100 text-foreground-500", label: "Morto" },
};

export const riscoConfig: Record<string, { badge: string; label: string }> = {
  baixo: { badge: "bg-primary-100 text-primary-700", label: "Baixo" },
  BAIXO: { badge: "bg-primary-100 text-primary-700", label: "Baixo" },
  medio: { badge: "bg-caution-100 text-caution-700", label: "Médio" },
  MEDIO: { badge: "bg-caution-100 text-caution-700", label: "Médio" },
  alto: { badge: "bg-warning-100 text-warning-700", label: "Alto" },
  ALTO: { badge: "bg-warning-100 text-warning-700", label: "Alto" },
  critico: { badge: "bg-danger-100 text-danger-700", label: "Crítico" },
  CRITICO: { badge: "bg-danger-100 text-danger-700", label: "Crítico" },
};

export const statusRevisaoConfig: Record<string, { badge: string; label: string }> = {
  cadastrada: { badge: "bg-secondary-100 text-secondary-700", label: "Cadastrada" },
  "em revisão": { badge: "bg-warning-100 text-warning-700", label: "Em Revisão" },
  validada: { badge: "bg-primary-100 text-primary-700", label: "Validada" },
  "pendente de informação": { badge: "bg-caution-100 text-caution-700", label: "Pendente" },
  "não localizada": { badge: "bg-danger-100 text-danger-700", label: "Não Localizada" },
  arquivada: { badge: "bg-background-100 text-foreground-500", label: "Arquivada" },
};

export const workflowStatusConfig: Record<string, { badge: string; label: string }> = {
  DRAFT: { badge: "bg-background-100 text-foreground-600", label: "Rascunho" },
  IN_PROGRESS: { badge: "bg-secondary-100 text-secondary-700", label: "Em Andamento" },
  SUBMITTED: { badge: "bg-caution-100 text-caution-700", label: "Submetida" },
  UNDER_REVIEW: { badge: "bg-warning-100 text-warning-700", label: "Em Revisão" },
  RETURNED: { badge: "bg-danger-100 text-danger-700", label: "Devolvida" },
  VALIDATED: { badge: "bg-primary-100 text-primary-700", label: "Validada" },
  CONCLUDED: { badge: "bg-primary-50 text-primary-600", label: "Concluída" },
  CANCELLED: { badge: "bg-background-100 text-foreground-500", label: "Cancelada" },
};

export const estadosFitossanitarios = ["bom", "regular", "ruim", "critico", "morto"];

export const classesRisco = ["baixo", "medio", "alto", "critico"];

export const recomendacoesManejo = [
  "Sem intervenção",
  "Monitorar",
  "Poda de limpeza",
  "Poda corretiva",
  "Poda emergencial",
  "Tratamento fitossanitário",
  "Supressão",
  "Transplante",
  "Replantio",
  "Vistoria complementar",
];

export const fotosTipos = [
  { value: "todas", label: "Todas" },
  { value: "geral", label: "Geral" },
  { value: "copa", label: "Copa" },
  { value: "tronco", label: "Tronco" },
  { value: "raiz", label: "Raiz" },
  { value: "interferencia", label: "Interferência" },
  { value: "dano", label: "Dano" },
  { value: "documento", label: "Documento" },
];
